require('./bootstrap');

import Alpine from 'alpinejs';
// import * as Turbo from "@hotwired/turbo";
import IMask from 'imask';

import slug from "alpinejs-slug";



Alpine.plugin(slug);

window.Alpine = Alpine;

Alpine.start();
